import React from "react";
import { Card, Divider, Typography } from "antd";
import DailyReport from "../../../../components/Kanban-Count-Accuracy/Report/DailyReport/DailyReport";
import "../../../../styles/global-ui.css";

const DailyReportPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Daily Report
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            View day-wise kanban count and accuracy details
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <DailyReport userData={userData} />
      </Card>
    </div>
  );
};

export default DailyReportPage;